module.exports = __webpack_public_path__ + "static/media/16.b38d7ac5.png";